import { writable } from 'svelte/store';
import { l } from "$lib/Utils/l10n.svelte";

const title = writable(l("start"));

const titleStore = {
    subscribe: title.subscribe,
    set : title.set,
    clear: () => {
        title.set(l("Home"));
    }
}
export default titleStore;
